import React, { useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, img } from "./kit";

// Seviye rozetleri: rutbe amblemi (her 10 seviyede bir, 18 adet) + "Lv" seridi. Bos olanda uygulamadaki resim cikar.
const hdr = () => ({ key: secretKey, Authorization: sessionStorage.getItem("token") || "" });

const LevelBadges = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () =>
    fetch(`${baseURL}customFrame/admin/levelBadges`, { headers: hdr() })
      .then((r) => r.json())
      .then((r) => r?.status && setD(r))
      .catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const yukle = async (slot, file) => {
    setBusy(String(slot));
    const fd = new FormData();
    if (file) fd.append("image", file);
    const r = await fetch(`${baseURL}customFrame/admin/levelBadges/${slot}`, { method: "POST", headers: hdr(), body: fd })
      .then((x) => x.json())
      .catch(() => null);
    setBusy("");
    if (!r?.status) return window.alert(r?.message || "Yüklenemedi");
    load();
  };

  const Kutu = ({ slot, label, src, varsayilan, wide }) => (
    <div className="card" style={{ margin: 0 }}>
      <div className="card-body" style={{ padding: 12, textAlign: "center" }}>
        <div style={{ fontWeight: 700, fontSize: 13 }}>{label}</div>
        <div style={{ height: 80, display: "flex", alignItems: "center", justifyContent: "center", background: "#0b0f1c", borderRadius: 10, margin: "8px 0" }}>
          <img src={src ? img(src) : varsayilan} alt="" style={{ maxHeight: wide ? 36 : 70, maxWidth: "90%" }} />
        </div>
        <div style={{ fontSize: 11, color: src ? "#16A34A" : "#6B7280", marginBottom: 6 }}>{src ? "Yeni resim" : "Uygulamadaki resim"}</div>
        <label className="btn btn-outline-primary btn-sm" style={{ margin: 0 }}>
          {busy === String(slot) ? "Yükleniyor…" : "Yükle"}
          <input type="file" accept="image/*" hidden onChange={(e) => e.target.files[0] && yukle(slot, e.target.files[0])} />
        </label>
        {src && (
          <button className="btn btn-outline-danger btn-sm" style={{ marginLeft: 6 }} onClick={() => window.confirm("Uygulamadaki resme dönülsün mü?") && yukle(slot)}>
            Sıfırla
          </button>
        )}
      </div>
    </div>
  );

  if (!d) return <div className="badu-empty">Yükleniyor…</div>;
  return (
    <>
      <PageHead title="Seviye Rozetleri" sub="Yüklediğin resim uygulamada hemen görünür (sürüm 1.6.7 ve üstü). Şeffaf PNG/WebP yükle. Boş bıraktığın yerde uygulamanın kendi resmi kalır." />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))", gap: 10, marginBottom: 16 }}>
        <Kutu slot="chip" label='"Lv" şeridi (yazı üstüne yazılır)' src={d.chip} varsayilan="/badge_level.webp" wide />
      </div>
      <b>Rütbe amblemi (seviyenin solunda)</b>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))", gap: 10, marginTop: 8 }}>
        {d.rank.map((u, i) => (
          <Kutu key={i} slot={i + 1} label={`Lv ${(i + 1) * 10}${i === 17 ? "+" : `–${(i + 1) * 10 + 9}`}`} src={u} varsayilan={`/levels/rank_${String(i + 1).padStart(2, "0")}.webp`} />
        ))}
      </div>
    </>
  );
};

export default LevelBadges;
